import React from "react";
import { Card, Divider, Typography } from "antd";
import GSM_Outward from "../../../components/GSuperMarket/GSM_Outward/GSM_Outward";
import "../../../styles/global-ui.css";

const GSM_OutwardPage = ({ userData }) => {
  return (
    <div className="page-container">
      <div className="page-header">
        <div className="page-title-wrap">
          <Typography.Title level={3} className="page-title">
            Bin Outward
          </Typography.Title>

          <Typography.Text className="page-subtitle">
            Process and send outward bins from garment supermarket
          </Typography.Text>
        </div>
      </div>

      <Divider className="page-divider" />

      <Card className="modern-card">
        <GSM_Outward userData={userData} />
      </Card>
    </div>
  );
};

export default GSM_OutwardPage;